import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';

import { NativeStackScreenProps } from '@react-navigation/native-stack';

import { InfoOutlinedIcon } from '@/assets/icons/info-outlined';
import { Screen } from '@/components/ScreenComponent';
import { ScreenNavBar } from '@/components/ScreenNavBar';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useAlerts } from '@/feature/alerts/hooks/use-alerts';
import { LineSteps } from '@/feature/invite-friends/components/LineSteps';
import { useRaf } from '@/feature/invite-friends/hooks/use-raf';
import { InviteFriendsStackParamList } from '@/navigation/types';
import { Rafv2DocumentDataActiveReferralsStepsItem } from '@/types/prismic.generated';

type ScreenProps = NativeStackScreenProps<InviteFriendsStackParamList, 'ReferralTracking'>;

export const ReferralTrackingScreen = (props: ScreenProps) => {
    const { referral } = props.route.params;
    //TODO: this will be changed with BE data
    const referralSettled = referral.status === 'settled';
    const referralAwardedOn = referral.awardedOn;
    const { data } = useRaf();
    const rafContent = data?.data;
    const { t } = useTranslation('raf');
    const { showInfoSheet } = useAlerts();

    //TODO: this component will use BE data: completedOn should come from BE for each step
    const updatedSteps = rafContent?.sender_referral_tracking_steps.map(
        (item: Rafv2DocumentDataActiveReferralsStepsItem) => ({
            ...item,
            completedOn: '10/30/24',
        })
    );

    const onPressInfoIcon = () => {
        showInfoSheet({
            title: t('promo_expired'),
            description: t('promo_expired_description'),
            buttonLabel: t('got_it'),
        });
    };

    return (
        <Screen>
            <ScreenNavBar title={t('refer_a_friend')} subTitle={`${t('sent_to')} Alex C.`} />
            <Box paddingHorizontal={'s16'}>
                {referralSettled ? null : (
                    <Row
                        marginTop={'s24'}
                        paddingVertical={'s12'}
                        paddingHorizontal={'s16'}
                        borderRadius={'r10'}
                        backgroundColor={ds.colorToken.background.danger.strong}
                        alignItems={'center'}
                    >
                        <TouchableOpacity activeOpacity={0.8} onPress={onPressInfoIcon}>
                            <InfoOutlinedIcon color={ds.colorValue.background.danger.strong} />
                        </TouchableOpacity>
                        <SizedBox value={16} />
                        <Text variant={'titleSmall'} letterSpacing={-0.08} color={ds.colorToken.text.danger}>
                            {t('promo_expired')}
                            <Text variant={'bodySmall'} color={ds.colorToken.text.danger}>
                                {' '}
                                {referralAwardedOn}
                            </Text>
                        </Text>
                    </Row>
                )}
                <Box paddingTop={'s22'}>
                    <Text variant={'headlineMedium'}>{t('refer_a_friend')}</Text>
                    <SizedBox value={8} />
                    <Text variant={'bodyMedium'} color={ds.colorToken.text.secondary}>
                        {rafContent?.sender_referral_tracking_description}
                    </Text>
                    <SizedBox value={32} />
                    <LineSteps steps={updatedSteps} />
                </Box>
            </Box>
        </Screen>
    );
};
